export const TEST_IDS = {
  Invoice: {
    customerPicker: 'invoiceCustomerPicker',
    invoiceSeriesName: 'invoiceSeriesName',
    productNamePicker: 'invoiceProductNamePicker',
    productQuantityInput: 'invoiceProductQuantityInput',
    productDescriptionInput: 'invoiceProductDescriptionInput',
    productPriceInput: 'invoiceProductPriceInput',
    productDiscountInput: 'invoiceProductDiscountInput',
    productUnitPicker: 'invoiceProductUnitPicker',
    receivingNotePurposePicker: 'invoiceReceivingNotePurposePicker',
    taxWithholdSelect: 'invoiceProductTaxWithholdSelect',
    shippingSelect: 'shippingSelect',
    shipFromInput: 'shipFromInput',
    shipToAddressInput: 'shipToAddressInput',
    shipToCitySelect: 'shipToCitySelect',
    shipToPostalCodeSelect: 'shipToPostalCodeSelect',
  },
  Delivery: {
    confirmOutcomeSelect: 'deliveryConfirmOutcomeSelect',
    deliveredWithoutRecipientSelect: 'deliveryDeliveredWithoutRecipientSelect',
    packagingTypeSelect: 'deliveryPackagingTypeSelect',
    transportTypeSelect: 'deliveryTransportTypeSelect',
  },
  Shared: {
    bSelectSearch: 'bSelectSearch',
    deleteIconButton: 'deleteIconButton',
  },
} as const;

export type TEST_IDS_TYPE = {
  [K in keyof typeof TEST_IDS]: (typeof TEST_IDS)[K][keyof (typeof TEST_IDS)[K]];
}[keyof typeof TEST_IDS];
